module.exports = __webpack_public_path__ + "static/media/fire.99f6a8e2.png";